import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("vs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, role = "user") => {
    const { data } = await api.post("/auth/register", { name, email, password, role });
    if (data.token) localStorage.setItem("vs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("vs_token");
    setUser(null);
  };

  const checkEmailExists = async (email) => {
    const { data } = await api.post("/auth/check-email", { email });
    return data.exists;
  };

  const requestOtp = async (phone) => {
    const { data } = await api.post("/auth/otp/request", { phone });
    return data;
  };

  const verifyOtp = async (phone, code) => {
    const { data } = await api.post("/auth/otp/verify", { phone, code });
    if (data.token) localStorage.setItem("vs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = async (credential) => {
    const { data } = await api.post("/auth/google", { credential });
    if (data.token) localStorage.setItem("vs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        register,
        logout,
        refresh: fetchMe,
        checkEmailExists,
        requestOtp,
        verifyOtp,
        loginWithGoogle,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
